import { EProjectPermission } from "@frontend-shared/types";
import { useMemo } from "react";

import { usePermissionCheck } from "./use-permission";

export interface ICallAssistantPermissions {
  canRead: boolean;
  canWrite: boolean;
  canDelete: boolean;
}

// NOTE: Single source of truth for AI Notetaker (call_assistant) RBAC in the
// UI. Resolves against the CURRENTLY ACTIVE project — usePermissionCheck reads
// the active project's permission map and already treats the "*" wildcard as
// all-true, so a personal project (wildcard membership, no RBAC) returns every
// flag true with no special-casing. The cross-project "any project" rule only
// applies to server-side auto-join, never to what the user sees here.
export const useCallAssistantPermissions = (): ICallAssistantPermissions => {
  const [canRead, canWrite, canDelete] = usePermissionCheck([
    EProjectPermission.CALL_ASSISTANT_READ,
    EProjectPermission.CALL_ASSISTANT_WRITE,
    EProjectPermission.CALL_ASSISTANT_DELETE,
  ]);

  return useMemo(
    () => ({ canRead, canWrite, canDelete }),
    [canRead, canWrite, canDelete],
  );
};
